// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2490":"55539d95b06982fa","4681":"ac06817b38c65ea5"}[chunkId] + ".css";
};